import { Grid2 } from "@mui/material";
import { Field, Form, Formik } from "formik";
import html2pdf from "html2pdf.js";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import { platformBlackLogo } from "../../../utils/logo";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import CommonAccordion from "../../common-components/CommonAccordion";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import AddExperience from "./components/AddExperience";
import ELCTable from "./components/ELCTable";
import ElcDialog from "./components/ElcDialog";
import Experience from "./components/Experience";
import MixedComponent from "./components/MixedComponent";
import Profile from "./components/Profile";
import References from "./components/References";
import { coversheetKarthik } from "./data";
import SkillDeleteDialog from "../../common-components/DeleteDialog";

function CandidatePerspective() {
  const query = new URLSearchParams(useLocation().search);
  const coverId = query.get("id");
  const view_resume = query.get("view_resume");
  const getValue = query.get("key");
  const dispatch = useDispatch();
  const coverSheet = "";
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [elcPopup, setElcPopup] = useState({
    open: false,
    loading: false,
    title: "",
    button: "",
    start_date: "",
    end_date: "",
    name: "",
    index: "",
    form: "",
  });
  const [elcExperience, setElcExperience] = useState({
    open: false,
    loading: false,
    position: "",
    company: "",
    button: "Add",
    index: "",
    form: "",
  });
  const [submitLoading, setSubmitLoading] = useState(false);

  const [deleteElc, setDeleteElc] = useState({
    open: false,
    loading: false,
    content: "",
    title: "",
    index: "",
    form: "",
  });
  const coverSheetModifyData = {
    first_name: "",
    middle_name: "",
    last_name: "",
    title: "",
    seniority_level: "",
    available_industry: [
      {
        name: "Mid Level",
      },
      {
        name: "Senior",
      },
      {
        name: "Fresher",
      },
      {
        name: "Junior",
      },
      {
        name: "Executive",
      },
    ],
    rate: {
      max: "",
      min: "",
      period: "Hourly",
      currency: "",
    },
    location: "",
    dob: "",
    portfolio: "",
    email: "",
    phone_number: "",
    job_location: "",
    linkedin_url: "",
    willing_to_relocate: false,
    education: "",
    available_education: [
      {
        name: "PHD Degree",
      },
      {
        name: "Master's Degree",
      },
      {
        name: "Bachelor's Degree",
      },
    ],
    certificates: [],
    certificates_value: "",
    languages: [],
    languages_value: "",
    industry: [],
    industry_value: "",
    govt_security_clearance: false,
    dei: false,
    porche: null,
    porche_data: [{ name: "Yes" }, { name: "No" }],
    manager_name: "",
    department: "",
    employment_period: "",
    employment_type: "",
    employment_data: [{ name: "Permanent" }, { name: "Contract" }],
    tax_term: "",
    tax_term_data: [
      { name: "C2C" },
      { name: "1099" },
      { name: "W2 Contract" },
      { name: "W2 Employee" },
    ],
    emplopyer_name: "",
    emplopyer_phone: "",
    emplopyer_email: "",
    emplopyer_contact_name: "",
    hour_rate: "",
    contract_hour_rate: "",
    employee_hour_rate: "",
    visa_type: "",
    visa_type_data: [
      { name: "Citizen" },
      { name: "Legal Resident" },
      { name: "Work Permit H1B" },
      { name: "Work Permit TN" },
      { name: "EAD - OPT" },
      { name: "EAD – H4" },
      { name: "EAD – L2" },
      { name: "EAD – Legal Resident" },
    ],
    H1B_holder_company_name: "",
    visa_stamped: "",
    visa_stamped_data: [{ name: "Yes" }, { name: "No" }],
    visa_valid_from: "",
    visa_valid_to: "",
    qualifications: [],
    certifications: [],
    licenses: [],
    job_history: [],
    reference_name: "",
    reference_phone: "",
    interview_details: "",
  };

  const [coverSheetData, setCoverSheetData] = useState(coverSheetModifyData);

  const fetchCoverSheet = async () => {
    setIsLoading(true);
    let params = {
      id: coverId,
    };
    try {
      setIsLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setCoverSheetData({
      ...coverSheetData,
      ...(getValue === "2"
        ? { ...coversheetKarthik }
        : getValue === "3"
        ? { ...coversheetKarthik }
        : { ...coversheetKarthik }),
    });
  }, []);

  const handleAddExperience = (form) => {
    setElcExperience((prev) => ({
      ...prev,
      open: true,
      loading: false,
      position: "",
      company: "",
      button: "Add",
      index: "",
      form: form,
    }));
  };
  const handleCloseAddExperience = () => {
    setElcExperience((prev) => ({
      ...prev,
      open: false,
      loading: false,
      position: "",
      company: "",
      button: "",
      index: "",
      form: "",
    }));
  };

  const primaryData = [
    {
      title: "First Name",
      component: "input",
      disabled: coverSheetData.first_name?.length !== 0 || view_resume,
      fontSize: "15px",
      titleName: "first_name",
      placeholderFontSize: "15px",
      placeholder: "Enter your First Name",
    },
    {
      title: "Middle Name",
      component: "input",
      disabled: coverSheetData?.middle_name?.length !== 0 || view_resume,
      fontSize: "15px",
      titleName: "middle_name",
      placeholderFontSize: "15px",
      placeholder: "Enter your Middle Name",
    },
    {
      title: "Last Name",
      component: "input",
      fontSize: "15px",
      disabled: coverSheetData?.last_name?.length !== 0 || view_resume,
      titleName: "last_name",
      placeholderFontSize: "15px",
      placeholder: "Enter your Last Name",
    },
    // {
    //   title: "Avatar",
    //   component: "fileUpload",
    //   titleName: "company_name",
    // },
    {
      title: "Title",
      component: "input",
      disabled: coverSheetData?.title?.length !== 0 || view_resume,
      fontSize: "15px",
      titleName: "title",
    },
    {
      title: "Seniority Level",
      component: "dropDown",
      titleName: "seniority_level",
      disabled: coverSheetData?.seniority_level?.length !== 0 || view_resume,
      dropDownData: "available_industry",
    },
    {
      component: "input-select",
      data: [
        {
          title: "Minimal Hour Rate",
          component: "input-select",
          fontSize: "15px",
          titleName: "rate",
          currency: "min",
          disabled: coverSheetData?.rate?.min !== "" || view_resume,
        },
        {
          title: "Maximal Hour Rate",
          component: "input-select",
          fontSize: "15px",
          titleName: "rate",
          currency: "max",
          disabled: coverSheetData?.rate?.max !== "" || view_resume,
        },
      ],
    },
    {
      title: "Primary Location",
      component: "input",
      titleName: "location",
      fontSize: "15px",
      disabled: coverSheetData?.location?.length !== 0 || view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your location",
    },
    {
      title: " Day and Month of Birth",
      name: "Oct 30",
      component: "single-calender",
      titleName: "dob",
      disabled: coverSheetData?.dob !== "" || view_resume,
    },
    {
      title: "Client / Job Location",
      component: "input",
      titleName: "job_location",
      fontSize: "15px",
      disabled: coverSheetData?.job_location?.length !== 0 || view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your location",
    },
    {
      title: "Primary Email Address",
      component: "input",
      fontSize: "15px",
      titleName: "email",
      disabled: coverSheetData?.email?.length !== 0 || view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your primary email address",
    },
    {
      title: "Primary Mobile Phone",
      component: "input",
      fontSize: "15px",
      titleName: "phone_number",
      disabled: coverSheetData?.phone_number?.length !== 0 || view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your primary mobile phone number",
    },
    {
      title: "Portfolio",
      size: true,
      component: "input-link",
      titleName: "portfolio",
      disabled: coverSheetData?.portfolio?.length !== 0 || view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your portfolio URL",
    },
    {
      title: "LinkedIn",
      size: true,
      component: "input-link-linkedin",
      titleName: "linkedin_url",
      disabled: coverSheetData?.linkedin_url?.length !== 0 || view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your linkedin URL",
    },
    {
      title: "Are you willing to relocate?",
      size: true,
      disabled: coverSheetData?.willing_to_relocate !== "" || view_resume,
      toggleName: "willing_to_relocate",
      type: "additional",
    },
  ];

  const additionalInforamtion = [
    {
      title: "Highest Level of Education",
      disabled: coverSheetData?.education?.length !== 0 || view_resume,
      component: "dropDown",
      titleName: "education",
      dropDownData: "available_education",
    },
    {
      title: "Certificates",
      disabled: coverSheetData?.certificates?.length !== 0 || view_resume,
      component: "autoComplete",
      titleName: "certificates",
      placeholder: "Enter Certificates",
      inputValue: "certificates_value",
    },
    {
      title: "Industry",
      component: "autoComplete",
      disabled: coverSheetData?.industry?.length !== 0 || view_resume,
      titleName: "industry",
      placeholder: "Enter Industry",
      inputValue: "industry_value",
    },
    {
      title: "Languages",
      component: "autoComplete",
      disabled: coverSheetData?.languages?.length !== 0 || view_resume,
      titleName: "languages",
      placeholder: "Enter Languages",
      inputValue: "languages_value",
    },

    {
      title: "Goverment / Security Classification",
      toggleName: "govt_security_clearance",
      type: "additional",
      disabled: coverSheetData?.govt_security_clearance !== "" || view_resume,
    },
    // {
    //   title: "DEI",
    //   toggleName: "dei",
    //   type: "additional",
    //   disabled: coverSheetData?.dei !== "" || view_resume,
    // },
  ];

  const previousExperience = [
    {
      title: "Have you worked in the past with Dave and Busters?",
      component: "dropDown",
      titleName: "porche",
      dropDownData: "porche_data",
      disabled: coverSheetData?.porche !== null || view_resume,
      customSize: true,
    },
  ];

  const conditionalExperience = [
    {
      title: "Employment Period",
      titleName: "employment_period",
      component: "single-calender",
      placeholder: "Select period",
      disabled: coverSheetData?.porche !== null || view_resume,
    },
    {
      title: "Department",
      component: "input",
      fontSize: "15px",
      titleName: "department",
      placeholderFontSize: "15px",
      placeholder: "Enter department",
      disabled: coverSheetData?.porche !== null || view_resume,
    },

    {
      title: "Type of Employment",
      component: "dropDown",
      titleName: "employment_type",
      dropDownData: "employment_data",
      placeholder: "Select Answer",
      disabled: coverSheetData?.porche !== null || view_resume,
    },
    {
      title: "Manager Name",
      component: "input",
      fontSize: "15px",
      titleName: "manager_name",
      placeholderFontSize: "15px",
      placeholder: "Enter manager name",
      disabled: coverSheetData?.porche !== null || view_resume,
    },
  ];


  const tax_term = [
    {
      title: "Tax Term",
      component: "dropDown",
      titleName: "tax_term",
      dropDownData: "tax_term_data",
      placeholder: "Select tax term",
      disabled: coverSheetData?.tax_term !== null || view_resume,
    },
  ];

  const conditional_C2C = [
    {
      title: "Employer Name",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_name",
      placeholderFontSize: "15px",
      placeholder: "Enter Employer Name",
      disabled: coverSheetData?.tax_term !== null || view_resume,
    },
    {
      title: "Hourly Bill Rate",
      component: "hour",
      fontSize: "15px",
      titleName: "hour_rate",
      placeholder: "Enter Hourly rate",
      disabled: coverSheetData?.tax_term !== null || view_resume,
    },
    {
      title: "Employer Phone",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_phone",
      placeholderFontSize: "15px",
      placeholder: "Enter Employer Phone",
      disabled: coverSheetData?.tax_term !== null || view_resume,
    },
    {
      title: "Employer Email",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_email",
      placeholderFontSize: "15px",
      placeholder: "Enter Email",
      disabled: coverSheetData?.tax_term !== null || view_resume,
    },
    {
      title: "Employer Contact Name",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_contact_name",
      placeholderFontSize: "15px",
      placeholder: "Enter Contact Name",
      disabled: coverSheetData?.tax_term !== null || view_resume,
    },
  ];

  const conditional_w2contract = [
    {
      title: "All Inclusive Hourly Pay Rate",
      component: "hour",
      fontSize: "15px",
      placeholderFontSize: "15px",
      titleName: "contract_hour_rate",
      placeholder: "Enter Hourly rate",
      disabled: coverSheetData?.tax_term !== null || view_resume,
    },
  ];

  const conditional_w2employee = [
    {
      title: "All Inclusive Hourly Pay Rate or Annual Salary",
      component: "hour",
      fontSize: "15px",
      placeholderFontSize: "15px",
      titleName: "employee_hour_rate",
      placeholder: "Enter Hourly rate",
      disabled: coverSheetData?.tax_term !== null || view_resume,
    },
  ];

  const visa_status = [
    {
      title: "Visa Type",
      component: "dropDown",
      titleName: "visa_type",
      dropDownData: "visa_type_data",
      placeholder: "Select visa type",
      disabled: coverSheetData?.visa_type !== null || view_resume,
    },
  ];

  const conditional_H1B = [
    {
      title: "Current H1B Holder Company Name",
      component: "input",
      fontSize: "15px",
      titleName: "H1B_holder_company_name",
      placeholderFontSize: "15px",
      placeholder: "Enter H1B Holder Company Name",
      disabled: coverSheetData?.visa_type !== null || view_resume,
    },
    {
      title: "Visa Stamped in Passport",
      component: "dropDown",
      titleName: "visa_stamped",
      dropDownData: "visa_stamped_data",
      placeholder: "Select Visa Stamp",
      disabled: coverSheetData?.visa_type !== null || view_resume,
    },
  ];

  const conditional_opt_ead = [
    {
      title: "Visa Valid From",
      titleName: "visa_valid_from",
      component: "single-calender",
      placeholder: "Select date",
      disabled: coverSheetData?.visa_information !== null || view_resume,
    },
    {
      title: "Visa Valid To",
      titleName: "visa_valid_to",
      component: "single-calender",
      placeholder: "Select date",
      disabled: coverSheetData?.visa_information !== null || view_resume,
    },
  ];

  const references = [
    {
      title: "Name",
      component: "input",
      fontSize: "15px",
      titleName: "reference_name",
      placeholderFontSize: "15px",
      placeholder: "Enter the name",
      disabled: coverSheetData?.reference_name !== "" || view_resume,
    },
    {
      title: "Phone",
      component: "input",
      fontSize: "15px",
      titleName: "reference_phone",
      placeholderFontSize: "15px",
      placeholder: "Enter the number",
      disabled: coverSheetData?.reference_phone !== "" || view_resume,
    },
    {
      title: "Interview Details",
      fontSize: "15px",
      titleName: "interview_details",
      placeholderFontSize: "15px",
      placeholder: "Enter details",
      disabled: coverSheetData?.interview_details !== "" || view_resume,
    },
  ];

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleCloseElc = () => {
    setElcPopup((prev) => ({
      ...prev,
      open: false,
      loading: false,
      title: "",
      button: "",
      start_date: "",
      end_date: "",
      name: "",
      index: "",
      form: "",
    }));
  };

  const handleElcDialog = (label, form) => {
    setElcPopup((prev) => ({
      ...prev,
      open: true,
      loading: false,
      title: label,
      button: "Add",
      start_date: "",
      end_date: "",
      name: "",
      index: "",
      form: form,
    }));
  };

  const handleElcEdit = (title, data, index, form) => {
    setElcPopup((prev) => ({
      ...prev,
      open: true,
      title: title,
      button: "Update",
      start_date: data?.start_date,
      end_date: data?.end_date,
      name: data?.name,
      index: index,
      form: form,
    }));
  };

  const handlELcSubmit = (title, values) => {
    setElcPopup((prev) => ({
      ...prev,
      loading: true,
    }));
    setIsLoading(true);
    let payload = {
      name: values.school,
      start_date: values.Date_range.start_date,
      end_date: values.Date_range.end_date,
    };

    if (title === "Add Education") {
      const previous_update = elcPopup.form.values;
      const updatedJobHistory = [...previous_update.qualifications];

      if (
        values.index !== undefined &&
        values.index !== null &&
        values.index !== ""
      ) {
        updatedJobHistory[values.index] = {
          ...updatedJobHistory[values.index],
          ...payload,
        };
      } else {
        updatedJobHistory.push(payload);
      }
      elcPopup.form.setFieldValue("qualifications", updatedJobHistory);
    } else if (title === "Add Licenses") {
      const previous_update = elcPopup.form.values;
      const updatedJobHistory = [...previous_update.licenses];

      if (
        values.index !== undefined &&
        values.index !== null &&
        values.index !== ""
      ) {
        updatedJobHistory[values.index] = {
          ...updatedJobHistory[values.index],
          ...payload,
        };
      } else {
        updatedJobHistory.push(payload);
      }
      elcPopup.form.setFieldValue("licenses", updatedJobHistory);
    } else if (title === "Add Certification") {
      const previous_update = elcPopup.form.values;
      const updatedJobHistory = [...previous_update.certifications];
      if (
        values.index !== undefined &&
        values.index !== null &&
        values.index !== ""
      ) {
        updatedJobHistory[values.index] = {
          ...updatedJobHistory[values.index],
          ...payload,
        };
      } else {
        updatedJobHistory.push(payload);
      }
      elcPopup.form.setFieldValue("certifications", updatedJobHistory);
    }
    setTimeout(() => {
      setSnackbarState({
        open: true,
        message: "updated Successfully",
        severity: "success",
      });
      handleCloseElc();
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }, 1000);
  };

  const handlExperienceSubmit = (title, values) => {
    setElcExperience((prev) => ({
      ...prev,
      loading: true,
    }));
    setIsLoading(true);
    let payload = {
      job_title: values.position,
      company: values.company,
      start_date: values.Date_range.start_date,
      end_date: values.Date_range.end_date,
    };
    const previous_elcExperience = elcExperience.form.values;
    const updatedJobHistory = [...previous_elcExperience.job_history];
    if (
      values.index !== undefined &&
      values.index !== null &&
      values.index !== ""
    ) {
      updatedJobHistory[values.index] = {
        ...updatedJobHistory[values.index],
        ...payload,
      };
    } else {
      updatedJobHistory.push(payload);
    }
    elcExperience.form.setFieldValue("job_history", updatedJobHistory);

    setTimeout(() => {
      setSnackbarState({
        open: true,
        message: "updated Successfully",
        severity: "success",
      });
      handleCloseAddExperience();
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }, 1000);
  };
  const handleDeleteElcClose = () => {
    setDeleteElc((prev) => ({
      ...prev,
      open: false,
      loading: false,
      content: "",
      title: "",
      index: "",
      form: "",
    }));
  };

  const handleDeleteELC = (title, data, index, form) => {
    setDeleteElc((prev) => ({
      ...prev,
      open: true,
      loading: false,
      index: index,
      title: title,
      content: data.name,
      form: form,
    }));
  };
  const handleDeleteElc = () => {
    setDeleteElc((prev) => ({
      ...prev,
      loading: true,
    }));
    setIsLoading(true);
    const previous_elcdelete = deleteElc.form.values;

    if (deleteElc.title === "Add Education") {
      const updatedDelete = [...previous_elcdelete.qualifications];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index !== deleteElc.index
      );
      deleteElc.form.setFieldValue("qualifications", updatedQualifications);
      // setCoverSheetData((prev) => ({
      //   ...prev,
      //   qualifications: updatedQualifications,
      // }));
    } else if (deleteElc.title === "Add Licenses") {
      const updatedDelete = [...previous_elcdelete.licenses];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index !== deleteElc.index
      );
      deleteElc.form.setFieldValue("licenses", updatedQualifications);
      // setCoverSheetData((prev) => ({
      //   ...prev,
      //   licenses: updatedQualifications,
      // }));
    } else if (deleteElc.title === "Add Certification") {
      const updatedDelete = [...previous_elcdelete.certifications];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index !== deleteElc.index
      );
      deleteElc.form.setFieldValue("certifications", updatedQualifications);
      // setCoverSheetData((prev) => ({
      //   ...prev,
      //   certifications: updatedQualifications,
      // }));
    } else if (deleteElc.title === "Add Experience") {
      const updatedDelete = [...previous_elcdelete.job_history];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index !== deleteElc.index
      );
      deleteElc.form.setFieldValue("job_history", updatedQualifications);
      // setCoverSheetData((prev) => ({
      //   ...prev,
      //   job_history: updatedQualifications,
      // }));
    }
    setTimeout(() => {
      setSnackbarState({
        open: true,
        message: "Delete Successfully",
        severity: "success",
      });
      handleDeleteElcClose();
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }, 1000);
  };

  const handleExperienceEdit = (data, index, form) => {
    setElcExperience((prev) => ({
      ...prev,
      open: true,
      button: "Update",
      start_date: data?.start_date,
      end_date: data?.end_date,
      position: data?.job_title,
      company: data?.company,
      index: index,
      form: form,
    }));
  };
  const handleExperienceDelete = (title, data, index, form) => {
    setDeleteElc((prev) => ({
      ...prev,
      open: true,
      loading: false,
      index: index,
      title: title,
      content: data.job_title,
      form: form,
    }));
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("First Name is required"),
    // middle_name: Yup.string().required("Middle Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    title: Yup.string().required("Title is required"),
    seniority_level: Yup.string().required("Seniority Level is required"),
    rate: Yup.object().shape({
      min: Yup.number()
        .required("Minimum pay rate is required")
        .typeError("Minimum pay rate must be a number")
        .min(0, "Minimum pay rate cannot be negative"),
      max: Yup.number()
        .required("Maximum pay rate is required")
        .typeError("Maximum pay rate must be a number")
        .moreThan(
          Yup.ref("min"),
          "Maximum pay rate must be greater than the minimum"
        ),
    }),
    location: Yup.string().required("Location is required"),
    dob: Yup.string().required("Date of Birth is required"),
    job_location: Yup.string().required("Job Location is required"),
    email: Yup.string().required("Email is required"),
    phone_number: Yup.string().required("Phone is required"),
    // .matches(
    //   /^\d{10}$|^\d{3}-\d{3}-\d{4}$/,
    //   "Phone must be exactly 10 digits or in the format 123-456-7890"
    // ),
    linkedin_url: Yup.string()
      // .matches(
      //   /^https?:\/\/(www\.)?linkedin\.com\/.*$/,
      //   "LinkedIn URL must be valid (e.g., https://www.linkedin.com/...)"
      // )
      .required("LinkedIn URL is required"),
    education: Yup.string().required("Education is required"),

    industry: Yup.array()
      .min(1, "Please select at least one option")
      .required("This field is required"),
    languages: Yup.array()
      .min(1, "Please select at least one option")
      .required("This field is required"),
    porche: Yup.string()
      .required("Porche is required")
      .oneOf(["Yes", "No"], "Porche must be Yes or No"),
    manager_name: Yup.string().when("porche", {
      is: (value) => value === "Yes",
      then: (schema) => schema.required("Manager Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    department: Yup.string().when("porche", {
      is: (value) => value === "Yes",
      then: (schema) => schema.required("Department is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    employment_period: Yup.string().when("porche", {
      is: (value) => value === "Yes",
      then: (schema) => schema.required("Employment Period is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    employment_type: Yup.string().when("porche", {
      is: (value) => value === "Yes",
      then: (schema) => schema.required("Employment Type is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    tax_term: Yup.string()
      .required("Tax Term is required")
      .oneOf(
        ["C2C", "1099", "W2 Contract", "W2 Employee"],
        "Tax Term must be C2C or 1099 or W2 Contract or W2 Employee"
      ),

    emplopyer_name: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) => schema.required("Emplopyer Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    emplopyer_phone: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) => schema.required("Emplopyer Phone is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    emplopyer_email: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) => schema.required("Emplopyer Email Period is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    emplopyer_contact_name: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) => schema.required("Emplopyer Contact Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    hour_rate: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) => schema.required("Hour Rate is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    contract_hour_rate: Yup.string().when("tax_term", {
      is: (value) => value === "W2 Contract",
      then: (schema) => schema.required("Hour Rate is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    employee_hour_rate: Yup.string().when("tax_term", {
      is: (value) => value === "W2 Employee",
      then: (schema) => schema.required("Hour Rate is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    visa_type: Yup.string()
      .required("Visa Type is required")
      .oneOf(
        [
          "EAD - OPT",
          "EAD – H4",
          "EAD – L2",

          "Work Permit H1B",
          "Work Permit TN",
          "EAD – Legal Resident",
          "Citizen",
          "Legal Resident",
        ],
        "Visa Type must be EAD - OPT or EAD – H4 or EAD – L2 or Work Permit H1B or Work Permit TN or EAD – Legal Resident"
      ),

    visa_valid_from: Yup.string().when("visa_type", {
      is: (value) =>
        value === "EAD - OPT" ||
        value === "EAD – H4" ||
        value === "EAD – L2" ||
        value === "Work Permit H1B" ||
        value === "Work Permit TN" ||
        value === "EAD – Legal Resident",
      then: (schema) => schema.required("Date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    visa_valid_to: Yup.string().when("visa_type", {
      is: (value) =>
        value === "EAD - OPT" ||
        value === "EAD – H4" ||
        value === "EAD – L2" ||
        value === "Work Permit H1B" ||
        value === "Work Permit TN" ||
        value === "EAD – Legal Resident",
      then: (schema) =>
        schema
          .required("To date is required")
          .test(
            "is-greater-than-from",
            "To date must be greater than From date",
            function (value) {
              const { visa_valid_from } = this.parent;
              if (!visa_valid_from || !value) return true;
              return new Date(value) > new Date(visa_valid_from);
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    H1B_holder_company_name: Yup.string().when("visa_type", {
      is: (value) =>
        value === "H1B" ||
        value === "Work Permit H1B" ||
        value === "Work Permit TN" ||
        value === "EAD – Legal Resident",
      then: (schema) => schema.required("Company Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    visa_stamped: Yup.string().when("visa_type", {
      is: (value) =>
        value === "H1B" ||
        value === "Work Permit H1B" ||
        value === "Work Permit TN" ||
        value === "EAD – Legal Resident",
      then: (schema) => schema.required("Visa Stamp is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const handleScrollToError = (errors) => {
    setTimeout(() => {
      const errorElement = document.querySelector(".Mui-error");
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 0);
  };

  const handleSubmit = async (values) => {
    setSubmitLoading(true);
    setIsLoading(true);

    setTimeout(() => {
      setSnackbarState({
        open: true,
        message: "Updated Successfully",
        severity: "success",
      });
      setSubmitLoading(false);
      setIsLoading(false);
    }, 1000);
  };

  const printableRef = useRef();

  const handleDownloadPDF = async () => {
    setSubmitLoading(true);
    const element = printableRef.current;
    const width = element.offsetWidth;
    const height = element.offsetHeight;
    const options = {
      margin: [20, 20, 20, 20],
      filename: "Coversheet.pdf",
      image: { type: "jpeg", quality: 2 },
      html2canvas: { scale: 3 },
      jsPDF: {
        unit: "px",
        format: [width + 250, height + 100],
        orientation: "portrait",
      },
    };

    try {
      await html2pdf().set(options).from(element).save();
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Grid2
      alignItems="center"
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      backgroundColor="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <div style={{ position: "relative" }}>
        {view_resume && (
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="600"
            padding={"10px 15px"}
            value="Download"
            width={"max-content"}
            disabled={submitLoading}
            loading={submitLoading}
            onClick={handleDownloadPDF}
            customStyle={{ position: "absolute", right: "0rem" }}
          />
        )}

        <div ref={printableRef}>
          <Formik
            enableReinitialize={true}
            initialValues={coverSheetData}
            validateOnMount={true}
            validationSchema={validationSchema}
            onSubmit={async (values, actions) => {
              handleSubmit(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
              form,
            }) => {
              const previous_experience_with_client = [...previousExperience];
              const previous_tax_term = [...tax_term];
              const previous_conditional_w2contract = [
                ...conditional_w2contract,
              ];
              const previous_conditional_w2employee = [
                ...conditional_w2employee,
              ];
              const previous_visa_status = [...visa_status];
              const previous_conditional_H1B = [...conditional_H1B];
              const previous_conditional_opt_ead = [...conditional_opt_ead];

              if (values.porche === "Yes") {
                previous_experience_with_client.push(...conditionalExperience);
              }
              if (values.tax_term === "C2C" || values.tax_term === "1099") {
                previous_tax_term.push(...conditional_C2C);
              }
              if (values.tax_term === "W2 Contract") {
                previous_tax_term.push(...previous_conditional_w2contract);
              }
              if (values.tax_term === "W2 Employee") {
                previous_tax_term.push(...previous_conditional_w2employee);
              }
              if (
                values.visa_type === "Work Permit H1B" ||
                values.visa_type === "Work Permit TN" ||
                values.visa_type === "EAD – Legal Resident"
              ) {
                previous_visa_status.push(...previous_conditional_H1B);
              }
              if (
                values.visa_type === "EAD - OPT" ||
                values.visa_type === "EAD – H4" ||
                values.visa_type === "EAD – L2" ||
                values.visa_type === "Work Permit H1B" ||
                values.visa_type === "Work Permit TN" ||
                values.visa_type === "EAD – Legal Resident"
              ) {
                previous_visa_status.push(...previous_conditional_opt_ead);
              }

              return (
                <Form
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.preventDefault();
                  }}
                >
                  <Field>
                    {({ field, form }) => (
                      <Grid2 container spacing={4}>
                        <Grid2 size={12}>
                          <CommonGrid2
                            display={"flex"}
                            flexDirection={"row"}
                            gap={"10px"}
                            width={"180px"}
                          >
                            {platformBlackLogo()}
                          </CommonGrid2>
                        </Grid2>
                        <Grid2 size={12}>
                          <Profile
                            handleScrollToError={handleScrollToError}
                            errors={errors}
                            coverSheet={coverSheetData}
                            loading={isLoading}
                            submitLoading={submitLoading}
                            view_resume={view_resume}
                            handleDownloadPDF={handleDownloadPDF}
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            title={"Primary Information"}
                            children={
                              <MixedComponent
                                editData={primaryData}
                                loading={isLoading}
                              />
                            }
                          />
                        </Grid2>

                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            title={"Additional Information"}
                            children={
                              <MixedComponent
                                editData={additionalInforamtion}
                                loading={isLoading}
                              />
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            title={"Previous Experience With The Client"}
                            children={
                              <MixedComponent
                                loading={isLoading}
                                editData={previous_experience_with_client}
                              />
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            title={"How We Engage"}
                            children={
                              <MixedComponent
                                editData={previous_tax_term}
                                loading={isLoading}
                              />
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            title={"Visa Status"}
                            children={
                              <MixedComponent
                                editData={previous_visa_status}
                                loading={isLoading}
                              />
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            title={"Experience"}
                            // disabled={isLoading || view_resume}
                            children={
                              <Experience
                                loading={isLoading}
                                data={values.job_history}
                                form={form}
                                title={"Add Experience"}
                                handleExperienceEdit={handleExperienceEdit}
                                handleExperienceDelete={handleExperienceDelete}
                                view_resume={view_resume}
                              />
                            }
                            accordionButton
                            disabled
                            buttonDisabled={isLoading || view_resume}
                            buttonTitle={"Add Experience"}
                            onButtonClick={() => handleAddExperience(form)}
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            disabled
                            title={"Education"}
                            children={
                              <ELCTable
                                loading={isLoading}
                                data={values.qualifications}
                                form={form}
                                handleElcEdit={handleElcEdit}
                                title={"Add Education"}
                                handleDeleteELC={handleDeleteELC}
                                view_resume={view_resume}
                              />
                            }
                            accordionButton
                            buttonTitle={"Add Education"}
                            onButtonClick={() =>
                              handleElcDialog("Add Education", form)
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            disabled={isLoading}
                            title={"Licences"}
                            children={
                              <ELCTable
                                loading={isLoading}
                                data={values.licenses}
                                form={form}
                                handleElcEdit={handleElcEdit}
                                title={"Add Licenses"}
                                handleDeleteELC={handleDeleteELC}
                                view_resume={view_resume}
                              />
                            }
                            accordionButton
                            buttonTitle={"Add Licenses"}
                            onButtonClick={() =>
                              handleElcDialog("Add Licenses", form)
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            disabled={isLoading}
                            title={"Certifications"}
                            children={
                              <ELCTable
                                loading={isLoading}
                                form={form}
                                data={values.certifications}
                                handleElcEdit={handleElcEdit}
                                title={"Add Certification"}
                                handleDeleteELC={handleDeleteELC}
                                view_resume={view_resume}
                              />
                            }
                            accordionButton
                            buttonTitle={"Add Certification"}
                            onButtonClick={() =>
                              handleElcDialog("Add Certification", form)
                            }
                          />
                        </Grid2>
                        <Grid2 size={12} fontFamily={"Inter"}>
                          <CommonAccordion
                            title={"References"}
                            children={
                              <References
                                data={references}
                                values={values}
                                setFieldValue={setFieldValue}
                                loading={isLoading}
                              />
                            }
                          />
                        </Grid2>
                        <AddExperience
                          open={elcExperience.open}
                          onClose={handleCloseAddExperience}
                          title={"Add Experience"}
                          handlExperienceSubmit={handlExperienceSubmit}
                          elcExperience={elcExperience}
                        />

                        <ElcDialog
                          open={elcPopup.open}
                          onClose={handleCloseElc}
                          title={elcPopup.title}
                          handlELcSubmit={handlELcSubmit}
                          elcPopup={elcPopup}
                        />
                        <SkillDeleteDialog
                          deleteDialog={deleteElc.open}
                          handleDeleteDialogClose={handleDeleteElcClose}
                          handleDeleteSkill={handleDeleteElc}
                          buttonLoading={deleteElc.loading}
                          title={deleteElc.title.replace("Add", "Delete")}
                          content={deleteElc.content}
                        />
                      </Grid2>
                    )}
                  </Field>
                </Form>
              );
            }}
          </Formik>
          <SnackBar
            snackbarState={snackbarState}
            handleCloseValidation={handleCloseValidation}
          />
        </div>
      </div>
    </Grid2>
  );
}

export default CandidatePerspective;
